<template>
    <el-row style="display: flex; height: 100%;" align="middle" :loading="pageLoading">
        <el-col :span="10" style="border: 1px solid #ccc; position: relative;">
            <img v-if="resType === 2" :src="link" alt="" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); max-width: 90%; max-height: 90%;">
            <video v-else :src="link" controls="controls" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); max-width: 90%; max-height: 90%;"></video>
        </el-col>
        <el-col :span="14" style="border: 1px solid #ccc; padding: 10px; overflow-y: scroll;">
            <div v-if="auditStatus === 0 || auditStatus === 1">
                <div class="loader loader--spinningDisc"></div>
                <div style="font-size: 27px;">
                    <span v-if="resultCheckTimes < 10 || true">审核中......</span>
                    <span v-else>审核进行中，等待时间较长，可继续等待，或稍后去管理中心查看审核记录</span>
                </div>
            </div>
            <div v-else-if="auditStatus === 2" style="margin-top: 150px; font-size: 27px; color: limegreen;">
                审核通过，资源正常
            </div>
            <el-tabs v-if="auditStatus === 3" type="border-card" class="audit-result">
                <el-tab-pane v-for="typeItem in errorList" :label="typeItem.type" :key="typeItem.type">
                    <!-- 关键词、文本、审核物料、缩略图 -->
                    <el-table border :data="typeItem.data">
                        <template v-if="typeItem.type === '错别字'">
                            <el-table-column prop="word" label="错别字" width="120"></el-table-column>
                            <el-table-column prop="trueword" label="建议修改" width="120"></el-table-column>
                            <el-table-column prop="text" label="所在文本"></el-table-column>
                        </template>
                        <template v-else-if="typeItem.type === '敏感词'">
                            <el-table-column prop="word" label="敏感词" width="120"></el-table-column>
                            <el-table-column prop="senstype" label="敏感词类型" width="120"></el-table-column>
                            <el-table-column prop="text" label="所在文本"></el-table-column>
                        </template>
                        <template v-else-if="typeItem.type === '禁用词'">
                            <el-table-column prop="word" label="禁用词" width="120"></el-table-column>
                            <el-table-column prop="text" label="所在文本"></el-table-column>
                        </template>
                        <template v-else-if="typeItem.type === '疑似错别字'">
                            <el-table-column prop="word" label="疑似错别字" width="120"></el-table-column>
                            <el-table-column prop="trueword" label="建议修改" width="120"></el-table-column>
                            <el-table-column prop="text" label="所在文本"></el-table-column>
                        </template>
                        <template v-else>
                            <el-table-column prop="errType" label="问题类型" width="120"></el-table-column>
                            <el-table-column prop="keyword" label="关键词" width="120"></el-table-column>
                            <el-table-column prop="text" label="文本"></el-table-column>
                            <el-table-column prop="timeInSeconds" label="所在位置" width="180" align="center" v-if="resType === 3 || resType === 4">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.multi === true">{{ scope.row.timeInSeconds }} - {{ scope.row.endSeconds }}</span>
                                    <span v-else>{{ scope.row.timeInSeconds }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="thumbnail" label="缩略图" width="200" align="center" v-if="resType !== 4">
                                <template slot-scope="scope">
                                    <img class="err-thumbnail" :src="scope.row.thumbnail" alt="" height="100px" @click="zoomImg(scope.row.thumbnail)">
                                </template>
                            </el-table-column>
                        </template>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
            <el-dialog :visible.sync="zoomImgDlg.show" width="700px" :append-to-body="true">
                <div>
                    <img :src="zoomImgDlg.image" alt="" style="max-width: 90%; max-height: 90%;">
                </div>
                <div slot="footer"></div>
            </el-dialog>
        </el-col>
    </el-row>
</template>

<script>
export default {
    data () {
        return {
            pageLoading: false,
            resType: 2,     // 2-图片 3-视频
            link: '',
            auditStatus: 0,
            resultCheckTimes: 0,
            errorList: [],
            zoomImgDlg: {
                show: false,
                image: ''
            }
        }
    },
    methods: {
        zoomImg(imgUrl) {
            this.zoomImgDlg.show = true
            this.zoomImgDlg.image = imgUrl
        },
        setPageLoading (val) { this.pageLoading = val },
        setResLink (resType, link) { this.resType = resType; this.link = link },
        setAuditResult (errlist) {
            console.log('设置审核结果：', this.resType, errlist)
            this.errorList = []
            this.auditStatus = errlist.length > 0 ? 3 : 2
            this.errorList = this.getFormatResult(errlist, this.resType === 3)
        },
        getFormatResult (resultList, isVideo) {
            var fmResults = []
            for (var errIdx in resultList) {
                var orgItem = resultList[errIdx]
                console.log('处理结果:', errIdx, orgItem)
                var typeExist = false;

                if (orgItem.scenes === '文本') {
                    for (var i = 0; i < fmResults.length; i++) {
                        if (fmResults[i].type === orgItem.subType) {
                            fmResults[i].data.push({
                                word: orgItem.word,
                                trueword: orgItem.trueword ? orgItem.trueword : '',
                                text: orgItem.text,
                                senstype: orgItem.senstype ? orgItem.senstype : ''
                            })
                            typeExist = true; break
                        }
                    }
                    if (!typeExist) {
                        fmResults.push({ type: orgItem.subType, data: [] })
                        fmResults[fmResults.length - 1].data.push({
                            word: orgItem.word,
                            trueword: orgItem.trueword ? orgItem.trueword : '',
                            text: orgItem.text,
                            senstype: orgItem.senstype ? orgItem.senstype : ''
                        })
                    }
                } else {
                    // 开始将resultList中的数据 合并写入 fmResults中
                    for (var i = 0; i < fmResults.length; i++) {
                        if (fmResults[i].type === orgItem.scenes) {    // 类型已存在，直接在类型下写入错误结果
                            typeExist = true
                            var typePos = i     // 当前类型位置
                            // 遍历当前类型下已有的结果，看是否有需要合并的
                            var errExists = false
                            for (var j = 0; j < fmResults[typePos].data.length; j++) {
                                var fmItem = fmResults[typePos].data[j]
                                if (isVideo && orgItem.subType === fmItem.errType && orgItem.extra === fmItem.keyword) {
                                    // 错误信息一样，看时间是否是连续或存在包含关系
                                    var checkRes = this.checkTimeContinue(fmItem.timeInSeconds, fmItem.endSeconds, orgItem.timeInSeconds)
                                    if (checkRes != null) {
                                        fmResults[typePos].data[j].multi = true
                                        fmResults[typePos].data[j].timeInSeconds = checkRes.stime
                                        fmResults[typePos].data[j].endSeconds = checkRes.etime
                                        if (fmResults[typePos].data[j].text.length < orgItem.text.length) fmResults[typePos].data[j].text = orgItem.text
                                        errExists = true
                                        break
                                    }
                                }
                            }
                            if(!errExists) {
                                fmResults[i].data.push({
                                    errType: orgItem.subType,
                                    keyword: orgItem.extra,
                                    text: orgItem.text,
                                    thumbnail: orgItem.thumbnail,
                                    timeInSeconds: ((isVideo || this.resType === 4) ? (orgItem.timeInSeconds.length == 8 ? orgItem.timeInSeconds : orgItem.timeInSeconds.substr(0, 8)) : 0),
                                    endSeconds: ((isVideo || this.resType === 4) ? (orgItem.timeInSeconds.length == 8 ? orgItem.timeInSeconds : orgItem.timeInSeconds.substr(9)) : 0),
                                    multi: false
                                })
                            }
                            break
                        }
                    }
                    if (!typeExist) {
                        fmResults.push({ type: orgItem.scenes, data: [] })
                        fmResults[fmResults.length - 1].data.push({
                            errType: orgItem.subType,
                            keyword: orgItem.extra,
                            text: orgItem.text,
                            thumbnail: orgItem.thumbnail,
                            timeInSeconds: ((isVideo || this.resType === 4) ? (orgItem.timeInSeconds.length == 8 ? orgItem.timeInSeconds : orgItem.timeInSeconds.substr(0, 8)) : 0),
                            endSeconds: ((isVideo || this.resType === 4) ? (orgItem.timeInSeconds.length == 8 ? orgItem.timeInSeconds : orgItem.timeInSeconds.substr(9)) : 0),
                            multi: false
                        })
                    }
                }
            }
            console.log('合并结果：', fmResults)
            return fmResults
        },
        checkTimeContinue(stime, etime, currtime) {
            if (stime.length != 8 || etime.length != 8) return null;
            var nStime = this.timeStrToInt(stime)
            var nEtime = this.timeStrToInt(etime)
            if(nStime == -1 || nEtime == -1) return null

            var nCurrSTime = -1; var nCurrETime = -1; var sCurrSTime = ''; var sCurrETime = '';
            if (currtime.length == 8) { nCurrSTime = this.timeStrToInt(currtime); nCurrETime = nCurrSTime; sCurrSTime = currtime; sCurrETime = currtime; }
            else if (currtime.length == 17) {
                sCurrSTime = currtime.substr(0, 8); nCurrSTime = this.timeStrToInt(sCurrSTime)
                sCurrETime = currtime.substr(9); nCurrETime = this.timeStrToInt(sCurrETime)
            }
            if(nCurrSTime == -1 || nCurrETime == -1) return null

            if (nCurrETime < nStime - 1 || nCurrSTime > nEtime + 1) return null // 两个时间范围没有交集，属于无关内容，不能合并
            return { stime: nCurrSTime < nStime ? sCurrSTime : stime, etime: nCurrETime > nEtime ? sCurrETime : etime }

            // if (nCurrETime == nStime - 1) return { stime: sCurrSTime, etime: etime }
            // else if (nCurrSTime == nEtime + 1) return { stime: stime, etime: currtime }
            // else if (nCurr >= nStime && nCurr <= nEtime) return { stime: stime, etime: etime }
            // else return null
        },
        timeStrToInt(stime) {
            var result = stime.match(/(\d+):(\d+):(\d+)/)
            if (result && result.length == 4) {
                return parseInt(result[1]) * 3600 + parseInt(result[2]) * 60 + parseInt(result[3])
            }
            return -1
        }
    }
}
</script>

<style>
.audit-result > .el-tabs--border-card > .el-tabs__content {
    position: absolute;
    top: 125px;
    bottom: 0px;
    left: 30px;
    right: 30px;
    overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/MediaAuditResult.vue